<template>
  <div class="sidebar-container">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="getMenuBackground"
        :text-color="getMenuTextColor" :unique-opened="true" :active-text-color="theme" :collapse-transition="false"
        mode="vertical" :class="sideTheme">
        <sidebar-item v-for="(route, index) in sidebarRouters" :key="route.path + index" :item="route"
          :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
    <el-tooltip :content="isCollapse ? $tt('展开导航') : $tt('收起导航')" :disabled="!isCollapse" placement="right">
      <button type="button" class="sidebar-collapse-button" :class="{ 'is-collapsed': isCollapse }"
        :aria-label="isCollapse ? $tt('展开导航') : $tt('收起导航')" :aria-expanded="!isCollapse"
        @click="appStore.toggleSideBar()">
        <el-icon aria-hidden="true"><Expand v-if="isCollapse" /><Fold v-else /></el-icon>
        <span v-if="!isCollapse">{{ $tt('收起导航') }}</span>
      </button>
    </el-tooltip>
  </div>
</template>

<script setup>
import SidebarItem from "./SidebarItem";
import { Expand, Fold } from "@element-plus/icons-vue";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";
import { useMixedNavigation } from "@/composables/useMixedNavigation";

const route = useRoute();
const appStore = useAppStore();
const settingsStore = useSettingsStore();
const { sidebarMenus: sidebarRouters, activePath: activeMenu } = useMixedNavigation();

const sideTheme = computed(() => settingsStore.sideTheme);
const theme = computed(() => "var(--sb-color-primary-text)");
const isCollapse = computed(() => !appStore.sidebar.opened);

// 获取菜单背景色
const getMenuBackground = computed(() => "var(--sidebar-bg)");

// 获取菜单文字颜色
const getMenuTextColor = computed(() => "var(--sidebar-text)");


</script>

<style lang="scss" scoped>
.sidebar-container {
  background-color: v-bind(getMenuBackground);

  .scrollbar-wrapper {
    background-color: v-bind(getMenuBackground);
  }

  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;

    .el-menu-item,
    .el-sub-menu__title {
      &:hover {
        background-color: var(--sb-bg-hover) !important;
      }
    }

    .el-menu-item {
      color: v-bind(getMenuTextColor);

      &.is-active {
        color: var(--menu-active-text, #7A5200);
        background-color: transparent !important;
      }
    }

    .el-sub-menu__title {
      color: v-bind(getMenuTextColor);
    }
  }
}
</style>
